(()=>{
'use strict';
const key='soleva-care-first-visit-v1',duration=30*60*1000;
let first=null,storage=null;
for(const name of ['localStorage','sessionStorage']){
  try{
    const candidate=window[name],existing=candidate.getItem(key);
    const value=existing===null?Date.now():Number(existing);
    if(!Number.isFinite(value)||value<=0||value>Date.now())break;
    if(existing===null)candidate.setItem(key,String(value));
    first=value;storage=candidate;break;
  }catch(e){}
}
function state(now=Date.now()){
  const deadline=first===null?null:first+duration;
  const seconds=deadline===null?0:Math.max(0,Math.ceil((deadline-now)/1000));
  return {deadline,seconds,active:seconds>0};
}
function render(){
  const current=state();
  document.querySelectorAll('[data-dispatch]').forEach(widget=>{
    widget.hidden=first===null;
    widget.classList.toggle('is-expired',!current.active);
    widget.querySelector('[data-dispatch-active]').hidden=!current.active;
    widget.querySelector('[data-dispatch-today]').hidden=!current.active;
    widget.querySelector('[data-dispatch-terms]').hidden=!current.active;
    widget.querySelector('.sc-dispatch-arrow').hidden=!current.active;
    widget.querySelector('[data-dispatch-expired]').hidden=current.active;
    widget.querySelector('[data-dispatch-time]').textContent=String(Math.floor(current.seconds/60)).padStart(2,'0')+':'+String(current.seconds%60).padStart(2,'0');
  });
}
window.SolevaDispatch={attributes(){return first===null?null:{'Soleva first visit (UTC)':new Date(first).toISOString(),'Soleva same-day deadline (UTC)':new Date(first+duration).toISOString()};}};
window.addEventListener('storage',event=>{
  if(event.storageArea!==storage||event.key!==key||event.newValue===null)return;
  const value=Number(event.newValue);
  if(Number.isFinite(value)&&value>0&&value<Date.now()&&(first===null||value<first)){first=value;render();}
});
document.addEventListener('visibilitychange',render);
window.addEventListener('pageshow',render);
render();setInterval(render,1000);
})();
